import { Component } from '@angular/core';

interface Location {
  id: number; name: string; address: string; city: string; country: string; status: string;
}

@Component({ selector: 'app-location-management', templateUrl: './location-management.component.html', styleUrl: './location-management.component.css' })
export class LocationManagementComponent {
  rows: Location[] = [
    { id: 1, name: 'Head Office',       address: '123 Main St',     city: 'New York',    country: 'USA',     status: 'active'   },
    { id: 2, name: 'West Branch',       address: '456 Oak Ave',     city: 'Los Angeles', country: 'USA',     status: 'active'   },
    { id: 3, name: 'North Hub',         address: '789 Pine Rd',     city: 'Chicago',     country: 'USA',     status: 'inactive' },
    { id: 4, name: 'South Campus',      address: '321 Elm Blvd',    city: 'Houston',     country: 'USA',     status: 'active'   },
    { id: 5, name: 'East Wing',         address: '654 Maple Dr',    city: 'Phoenix',     country: 'USA',     status: 'pending'  },
    { id: 6, name: 'Downtown Center',   address: '987 Cedar Ln',    city: 'Toronto',     country: 'Canada',  status: 'active'   },
  ];
}
